module.exports = __webpack_public_path__ + "img/symbol_0.1e766cfe.png";